import { BottomSheet, Icon, Modal, Text } from 'components'

import joinClassNames from 'utilities/joinClassNames'
import { useNavigate } from 'react-router-dom'
import { BankSlip, ChangePayment } from '../../../Modals'

import { useState } from 'react'

import { handlePayment } from './converter'

import { AccountPaymentResponse } from 'services/patrimony'

import styles from './styles.module.scss'
import { useToggle } from 'shared/hooks'

interface RegisteredPaymentProps {
  paymentMethod: AccountPaymentResponse
  accountId: string
}

const RegisteredPayment = ({
  paymentMethod,
  accountId,
}: RegisteredPaymentProps) => {
  const [shouldOpenSheet, setShouldOpenSheet] = useState(false)

  const navigate = useNavigate()
  const bankSlip = useToggle()

  const payment = handlePayment(paymentMethod)

  return (
    <div>
      <Modal.Root isOpen={bankSlip.isVisible} onClose={bankSlip.hide}>
        <BankSlip accountId={accountId} isEditing />
      </Modal.Root>

      <div className={joinClassNames(styles.content, styles.registered)}>
        <Icon name={payment?.icon || 'barcode'} width={24} />

        {!!payment && (
          <div>
            <Text weight="medium" size="md">
              {payment.title}
            </Text>

            {payment?.subtitle && (
              <Text
                weight="regular"
                size="sm"
                color="element-medium"
                className={styles.instruction}
              >
                {payment.subtitle}
              </Text>
            )}
          </div>
        )}
      </div>

      <BottomSheet.Root onClose={() => setShouldOpenSheet(false)}>
        <Modal.Root>
          <Modal.Trigger>
            <BottomSheet.Trigger>
              <div className={styles.add}>
                <Icon name="edit" color="accent-red-default" />
                <Text weight="medium" size="md" color="accent-red-default">
                  Alterar forma de pagamento
                </Text>
              </div>
            </BottomSheet.Trigger>
          </Modal.Trigger>

          <ChangePayment
            onConfirm={() => {
              if (paymentMethod.method === 'CREDIT_CARD') {
                return navigate(`/credit-card/${paymentMethod.id}/edit`)
              }

              setShouldOpenSheet(true)
            }}
          />
        </Modal.Root>

        {shouldOpenSheet && (
          <BottomSheet.Content>
            <BottomSheet.Title>Selecione uma opção</BottomSheet.Title>

            <BottomSheet.Option
              onClick={() => navigate(`/credit-card/${paymentMethod.id}/edit`)}
            >
              Cartão de crédito
            </BottomSheet.Option>

            <>
              <BottomSheet.Option
                onClick={() =>
                  navigate(`/direct-debit/${paymentMethod.id}/edit`)
                }
              >
                Débito em conta
              </BottomSheet.Option>

              <BottomSheet.Option onClick={bankSlip.show}>
                Boleto
              </BottomSheet.Option>
            </>
          </BottomSheet.Content>
        )}
      </BottomSheet.Root>
    </div>
  )
}

export default RegisteredPayment
